import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { LegalData } from '../../../domain/data/legal-data';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './legal.dialog.html',
    styleUrls: ['./legal.dialog.scss'],
})
export class LegalDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    constructor(el: ElementRef, parentEvents: ParentEvents, renderer: Renderer2, @Inject(MAT_DIALOG_DATA) public data: LegalData) {
        super(parentEvents, el, renderer);
    }
}
